import * as angular from 'angular';

export class BundleRequestService {
    constructor(private $filter: ng.IFilterService) {}

    private FIRM_CATEGORIES: CapacityCategory[] = [
        'FZK',
        'BZK',
        'B_FZK',
        'B_FZK_1',
        'B_FZK_C',
        'DZK',
        'DZK_1',
        'DZK_2',
        'DZK_3',
        'DZK_4',
        'DZK_5',
        'DZK_SH',
        'IUKCF_1',
        'FIRM',
        'FZK_C',
        'FZK_INC',
        'FIRM_ADDITIONAL',
        'INCREMENTAL_OFFER_LEVEL_1',
        'INCREMENTAL_OFFER_LEVEL_2',
        'INCREMENTAL_OFFER_LEVEL_3',
        'INCREMENTAL_OFFER_LEVEL_4',
        'INCREMENTAL_OFFER_LEVEL_5'
    ];

    private INTERRUPTIBLE_CATEGORIES: CapacityCategory[] = [
        'INTERRUPTIBLE',
        'INTERRUPTIBLE_LEVEL_1',
        'INTERRUPTIBLE_LEVEL_2',
        'INTERRUPTIBLE_LEVEL_N',
        'BACKHAUL_CAPACITY',
        'BACKHAUL_LEVEL_1',
        'BACKHAUL_LEVEL_2',
        'BACKHAUL_LEVEL_N',
        'U_BZK',
        'U_KC'
    ];

    public isFirm(capacityCategory: CapacityCategory) {
        return this.FIRM_CATEGORIES.indexOf(capacityCategory) != -1;
    }

    public isInterruptible(capacityCategory: CapacityCategory) {
        return this.INTERRUPTIBLE_CATEGORIES.indexOf(capacityCategory) != -1;
    }

    public slotAlreadyInSlotAssignments(
        slot: BundleChangeRequestSlotAssignmentDto,
        slotAssignments: BundleChangeRequestSlotAssignmentDto[],
        auctionAlgorithmType: AuctionAlgorithmType,
        direction: Direction
    ): boolean {
        let directionMap = new Map();
        directionMap.set(
            'BUNDLE',
            slotAssignments.filter(
                (sa) =>
                    !angular.isUndefined(sa.entryCategory) &&
                    !angular.isUndefined(sa.exitCategory)
            )
        );
        directionMap.set(
            'EXIT',
            slotAssignments.filter(
                (sa) =>
                    angular.isUndefined(sa.entryCategory) &&
                    !angular.isUndefined(sa.exitCategory)
            )
        );
        directionMap.set(
            'ENTRY',
            slotAssignments.filter(
                (sa) =>
                    !angular.isUndefined(sa.entryCategory) &&
                    angular.isUndefined(sa.exitCategory)
            )
        );

        let slotAssignmentsForDirection: BundleChangeRequestSlotAssignmentDto[] =
            directionMap.get(direction);

        return slotAssignmentsForDirection.some(
            (sa) =>
                sa.exitCategory == slot.exitCategory &&
                sa.entryCategory == slot.entryCategory &&
                sa.auctionAlgorithmType == auctionAlgorithmType
        );
    }

    public unbundledCapacityCategoryDifferentInBundledSlotAssignments(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[],
        auctionAlgorithmType: AuctionAlgorithmType,
        direction: Direction,
        category: CapacityCategory,
        slot: number
    ): boolean {
        for (let i = 0; i < slotAssignments.length; i++) {
            if (
                slotAssignments[i].slot != slot &&
                direction == 'EXIT' &&
                slotAssignments[i].auctionAlgorithmType ==
                    auctionAlgorithmType &&
                slotAssignments[i].exitCategory == category &&
                slotAssignments[i].entryCategory
            ) {
                return true;
            }
            if (
                slotAssignments[i].slot != slot &&
                direction == 'ENTRY' &&
                slotAssignments[i].auctionAlgorithmType ==
                    auctionAlgorithmType &&
                slotAssignments[i].entryCategory == category &&
                slotAssignments[i].exitCategory
            ) {
                return true;
            }
        }
        return false;
    }

    public bundledCapacityCategoryDifferentInUnbundledSlotAssignments(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[],
        auctionAlgorithmType: AuctionAlgorithmType,
        bundledSlot: BundleChangeRequestSlotAssignmentDto
    ): boolean {
        for (let i = 0; i < slotAssignments.length; i++) {
            if (
                slotAssignments[i].exitCategory == bundledSlot.exitCategory &&
                !slotAssignments[i].entryCategory &&
                angular.isDefined(slotAssignments[i].slot) &&
                slotAssignments[i].slot != bundledSlot.slot &&
                slotAssignments[i].auctionAlgorithmType == auctionAlgorithmType
            ) {
                return true;
            }
            if (
                slotAssignments[i].entryCategory == bundledSlot.entryCategory &&
                !slotAssignments[i].exitCategory &&
                angular.isDefined(slotAssignments[i].slot) &&
                slotAssignments[i].slot != bundledSlot.slot &&
                slotAssignments[i].auctionAlgorithmType == auctionAlgorithmType
            ) {
                return true;
            }
        }
        return false;
    }

    public bundledCapacityCategoryEmptyInUnbundledSlotAssignments(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[],
        auctionAlgorithmType: AuctionAlgorithmType,
        bundledSlot: BundleChangeRequestSlotAssignmentDto
    ): boolean {
        for (let i = 0; i < slotAssignments.length; i++) {
            if (
                slotAssignments[i].exitCategory == bundledSlot.exitCategory &&
                !slotAssignments[i].entryCategory &&
                angular.isUndefined(slotAssignments[i].slot) &&
                slotAssignments[i].auctionAlgorithmType == auctionAlgorithmType
            ) {
                return true;
            }
            if (
                slotAssignments[i].entryCategory == bundledSlot.entryCategory &&
                !slotAssignments[i].exitCategory &&
                angular.isUndefined(slotAssignments[i].slot) &&
                slotAssignments[i].auctionAlgorithmType == auctionAlgorithmType
            ) {
                return true;
            }
        }
        return false;
    }

    public canProcessConversation(
        bundleRequest: BundleChangeRequestDto,
        tsoRefId: number
    ) {
        return (
            bundleRequest.responderTsoRefId == tsoRefId &&
            (bundleRequest.state == 'REQUESTED' ||
                bundleRequest.state == 'COUNTER_PROPOSED')
        );
    }

    public isIntraTsoBundle(
        exitNetworkPoint: NetworkPointDto,
        entryNetworkPoint: NetworkPointDto
    ) {
        return exitNetworkPoint.tso0Id == entryNetworkPoint.tso0Id;
    }

    public getAllBundledSlotsFromSlotAssignments(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[],
        auctionAlgorithmType: AuctionAlgorithmType
    ): BundleChangeRequestSlotAssignmentDto[] {
        return this.$filter('filter')(slotAssignments, {
            auctionAlgorithmType: auctionAlgorithmType,
            exitCategory: '!!',
            entryCategory: '!!'
        });
    }

    public copyShortTermToLongTermSlotAssignments(
        slotAssignmentsShortTerm: BundleChangeRequestSlotAssignmentDto[]
    ): BundleChangeRequestSlotAssignmentDto[] {
        let longTermSlotOrder = angular.copy(slotAssignmentsShortTerm);
        angular.forEach(
            longTermSlotOrder,
            (slot) => (slot.auctionAlgorithmType = 'LONG_TERM')
        );
        return longTermSlotOrder;
    }

    public compareSlotOrders(bundleRequest: BundleChangeRequestDto): boolean {
        let shortTermSlotOrder = angular.copy(
            bundleRequest.slotAssignmentsShortTerm
        );
        let longTermSlotOrder = angular.copy(
            bundleRequest.slotAssignmentsLongTerm
        );

        angular.forEach(shortTermSlotOrder, (slot) => {
            delete slot.id;
            delete slot.auctionAlgorithmType;
        });

        angular.forEach(longTermSlotOrder, (slot) => {
            delete slot.id;
            delete slot.auctionAlgorithmType;
        });

        return (
            angular.equals(shortTermSlotOrder, longTermSlotOrder) &&
            angular.equals(
                bundleRequest.exitOrderShortTerm,
                bundleRequest.exitOrderLongTerm
            ) &&
            angular.equals(
                bundleRequest.entryOrderShortTerm,
                bundleRequest.entryOrderLongTerm
            )
        );
    }

    public areBundleSlotAssignmentsUnchanged(
        currentBundleRequest: BundleChangeRequestDto,
        previousBundleRequest: BundleChangeRequestDto
    ): boolean {
        let current = angular.copy(currentBundleRequest);
        let previous = angular.copy(previousBundleRequest);

        //remove ignorable fields
        delete current.id;
        delete current.requestingTsoRefId;
        delete current.senderTsoRefId;
        delete current.operation;
        delete current.state;
        delete current.parentBundleChangeRequestId;
        delete current.responderTsoRefId;
        delete current.conversationId;
        delete current.messageToResponder;
        delete current.changedAt;
        delete current.createdAt;
        delete current.exitOrderLongTerm;
        delete current.entryOrderLongTerm;
        delete current.exitOrderShortTerm;
        delete current.entryOrderShortTerm;

        delete previous.id;
        delete previous.requestingTsoRefId;
        delete previous.senderTsoRefId;
        delete previous.operation;
        delete previous.state;
        delete previous.parentBundleChangeRequestId;
        delete previous.responderTsoRefId;
        delete previous.conversationId;
        delete previous.messageToResponder;
        delete previous.changedAt;
        delete previous.createdAt;
        delete previous.exitOrderLongTerm;
        delete previous.entryOrderLongTerm;
        delete previous.exitOrderShortTerm;
        delete previous.entryOrderShortTerm;

        angular.forEach(current.slotAssignmentsShortTerm, (slot, index) => {
            delete slot.id;
            delete slot.bundleChangeRequestId;
        });

        angular.forEach(previous.slotAssignmentsShortTerm, (slot, index) => {
            delete slot.id;
            delete slot.bundleChangeRequestId;
        });

        angular.forEach(current.slotAssignmentsLongTerm, (slot, index) => {
            delete slot.id;
            delete slot.bundleChangeRequestId;
        });

        angular.forEach(previous.slotAssignmentsLongTerm, (slot, index) => {
            delete slot.id;
            delete slot.bundleChangeRequestId;
        });

        current.slotAssignmentsLongTerm = this.filterBundledAssignments(
            current.slotAssignmentsLongTerm
        );
        previous.slotAssignmentsLongTerm = this.filterBundledAssignments(
            previous.slotAssignmentsLongTerm
        );
        current.slotAssignmentsShortTerm = this.filterBundledAssignments(
            current.slotAssignmentsShortTerm
        );
        previous.slotAssignmentsShortTerm = this.filterBundledAssignments(
            previous.slotAssignmentsShortTerm
        );

        //order them alphabetical, since the tso has not to accept changes of the matching order
        current.slotAssignmentsLongTerm =
            this.orderCapacityCategoriesAlphabetical(
                current.slotAssignmentsLongTerm
            );
        previous.slotAssignmentsLongTerm =
            this.orderCapacityCategoriesAlphabetical(
                previous.slotAssignmentsLongTerm
            );
        current.slotAssignmentsShortTerm =
            this.orderCapacityCategoriesAlphabetical(
                current.slotAssignmentsShortTerm
            );
        previous.slotAssignmentsShortTerm =
            this.orderCapacityCategoriesAlphabetical(
                previous.slotAssignmentsShortTerm
            );

        return angular.equals(current, previous);
    }

    private filterBundledAssignments(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[]
    ): BundleChangeRequestSlotAssignmentDto[] {
        return this.$filter('filter')(slotAssignments, {
            exitCategory: '!!',
            entryCategory: '!!'
        });
    }

    private orderCapacityCategoriesAlphabetical(
        slotAssignments: BundleChangeRequestSlotAssignmentDto[]
    ) {
        return this.$filter('orderBy')(slotAssignments, [
            'exitCategory',
            'entryCategory'
        ]);
    }
}

angular.module('app').service('bundleRequestService', BundleRequestService);
